import React from 'react';
import { observer } from 'mobx-react-lite';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  CircularProgress,
  Typography,
  Box
} from '@mui/material';
import WorkingHoursEditor from './WorkingHoursEditor';

/**
 * WorkingHoursModal - Standalone modal for editing employee working hours
 * Uses the same WorkingHoursEditor component as the EmployeeFormModal
 */
const WorkingHoursModal = observer(({ open, onClose, employee, store, defaultWorkingHours }) => {
  const handleSubmit = async () => {
    if (!employee) return;

    try {
      await store.updateEmployee(employee._id || employee.id, {
        workingHours: store.formData.workingHours
      });
    } catch (err) {
      // Error is handled in the store
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        <Box>
          <Typography variant="h6">
            Editar Horários de Trabalho
          </Typography>
          {employee && (
            <Typography variant="body2" color="text.secondary">
              {employee.name}
            </Typography>
          )}
        </Box>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 1 }}>
          <WorkingHoursEditor
            store={store}
            defaultWorkingHours={defaultWorkingHours}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          disabled={store.isLoading}
        >
          {store.isLoading ? <CircularProgress size={20} /> : 'Salvar'}
        </Button>
      </DialogActions>
    </Dialog>
  );
});

export default WorkingHoursModal;
